import React from "react";

const Compensacoes = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Rota /compensacoes funcionando ✅</h1>
    </div>
  );
};

export default Compensacoes;